import {Text, View, SectionList, ImageBackground} from "react-native";
import React from "react";
import {LinearGradient} from "expo-linear-gradient";

import {styles, TAB_BAR_HEIGHT} from "../common/styles";
import {WhiteViewHeader} from "../common/WhiteViewHeader";
import {i18n} from "../common/localization";

import bg from "../assets/restaurant-bg.png";

export const SocialMenu = ({ title, data }) => {
    return (
        <View style={styles.container}>
            <ImageBackground source={bg} resizeMode="contain" style={{...styles.whiteViewBgImageContainer, width: 271, height: 118}} />
            <View style={{...styles.whiteViewContainer, paddingBottom: TAB_BAR_HEIGHT}}>
                <WhiteViewHeader/>
                <View style={styles.whiteViewScrollView}>
                    <View style={styles.whiteViewScrollView}>
                        <View style={styles.whiteViewScrollViewInnerContainer}>
                            <SectionList
                                stickySectionHeadersEnabled={false}
                                sections={data}
                                keyExtractor={(item, index) => item + index}
                                renderItem={({ item }) => <MenuItem item={item} />}
                                renderSectionHeader={({ section }) => <MenuSectionHeader section={section} />}
                                renderSectionFooter={() => <View style={{marginBottom: 30}}></View>}
                                ListHeaderComponent={
                                <>
                                    <Text style={{...styles.whiteViewTitleText, paddingHorizontal: 0}}>{title}</Text>
                                    {data[0] && data[0].price !== null &&
                                        <LinearGradient
                                            colors={["#EFF4F9", "#FFFFFF"]}
                                            locations={[0, 1]}
                                            style={styles.menu.perPersonView}>
                                            <Text style={styles.menu.perPersonText}>{i18n.t("perPerson")}</Text>
                                            <Text style={styles.menu.perPersonText}>€ {data[0].price}</Text>
                                        </LinearGradient>
                                    }
                                </>
                                }
                            />
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}

const MenuItem = ({ item }) => (
    <View style={styles.menu.itemView}>
        <View style={{flex: 1, paddingRight: 20}}>
            <Text style={styles.menu.itemTitle}>{item.title}</Text>
            {item.description !== null && item.description !== "" && <Text style={styles.menu.itemDescription}>{item.description}</Text>}
        </View>
        {item.price !== 0 && item.price !== null && <Text style={styles.menu.itemPrice}>€ {item.price}</Text>}
    </View>
);

const MenuSectionHeader = ({ section }) => (
    <Text style={styles.menu.sectionTitle}>{section.title}</Text>
);
